import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import { Spacer, Title, Text } from 'components/atoms';
import PropTypes from 'prop-types';
import modules, { moduleDefaults } from 'modules'

const Placeholder = ({ name, hasEditor }) => {
  const moduleProps = useMemo(() => {
    const modulesKeyArr = Object.keys(modules)
    const key = modulesKeyArr.find(moduleKey => moduleKey === name)
    if (!key) return moduleDefaults
    return modules[key]
  }, [name])

  const title = useMemo(
    () => (moduleProps && moduleProps.options && moduleProps.options.label) || name,
    [name, moduleProps]
  )

  const message = useMemo(() => (hasEditor ? 'Pré-visualização indisponível.' : 'Módulo indisponível, em desenvolvimento.'), [hasEditor])
  return (
    <Wrapper>
      <Spacer spacing="xl5">
        <Center>
          <Title>{title}</Title>
          <Text>{message}</Text>
        </Center>
      </Spacer>
    </Wrapper>
  );
}

Placeholder.propTypes = {
  name: PropTypes.string.isRequired,
  hasEditor: PropTypes.bool,
};

Placeholder.defaultProps = {
  hasEditor: false,
}

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Wrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.borderLighter};
`;

export default Placeholder;
